import { atom } from "jotai";

export const followersAtom = atom ( 0 );
